import React from 'react';
import { List, Typography } from '@mui/material';
import { Feed } from '../../api/models/Feed';
import FeedsRow from '../FeedsRow/FeedsRow';

interface FeedsTableProps {
  azureFeeds: Feed[];
  isLoading: boolean;
  onDeleteFeed: (feedName: string) => void;
}

const FeedsTable: React.FC<FeedsTableProps> = ({
  azureFeeds,
  isLoading,
  onDeleteFeed,
}) => {
  if (azureFeeds.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        No Azure Feeds found. Create your first feed to get started.
      </Typography>
    );
  }

  return (
    <List>
      {azureFeeds.map((feed, index) => (
        <FeedsRow
          key={`${feed.feedName}-${index}`}
          feed={feed}
          index={index}
          totalFeeds={azureFeeds.length}
          isLoading={isLoading}
          onDeleteFeed={onDeleteFeed}
        />
      ))}
    </List>
  );
};

export default FeedsTable;
